import classNames from 'classnames';
import { useCombobox } from 'downshift';
import React from 'react';
import { FormControl } from 'react-bootstrap';

const ComboboxEmployee = ({
  disabled,
  entities,
  onInputValueChange,
  onSelectedItemChange,
  isActive,
  controlId,
  multiple,
  disabledBlurClearing,
  pending,
}) => {
  const {
    getComboboxProps,
    getInputProps,
    getItemProps,
    getMenuProps,
    isOpen,
  } = useCombobox({
    items: entities,
    onInputValueChange: ({ inputValue }) => onInputValueChange(inputValue),
    onSelectedItemChange: ({ selectedItem }) =>
      onSelectedItemChange(selectedItem),
    selectedItem: null,
    stateReducer: (state, actionAndChanges) => {
      const { changes, type } = actionAndChanges;
      switch (type) {
        // case useCombobox.stateChangeTypes.InputKeyDownEnter:
        case useCombobox.stateChangeTypes.ItemClick:
          return {
            ...changes,
            isOpen: multiple,
            highlightedIndex: state.highlightedIndex,
            inputValue: '',
          };
        case useCombobox.stateChangeTypes.InputBlur:
          return disabledBlurClearing
            ? { ...changes }
            : { ...changes, inputValue: '' };
        default:
          return changes;
      }
    },
  });
  return (
    <div className={classNames('dropdown', { open: isOpen })}>
      <div className="input-group w-100" {...getComboboxProps()}>
        <FormControl
          placeholder="Start Typing"
          className="clear"
          {...getInputProps({ disabled, id: controlId, refKey: 'inputRef' })}
        />
      </div>
      <ul className="dropdown-menu" {...getMenuProps()}>
        {pending ? (
          <li>
            <a>Loading...</a>
          </li>
        ) : null}
        {entities.map((item, index) => {
          const { id, archived } = item;
          const active = isActive(id);
          const disabled = (!active && archived) || id === 'no-result';
          return (
            <li
              key={`search-employee-${id}`}
              className={classNames({ active, disabled })}
              {...getItemProps({
                index,
                tabIndex: index,
              })}
            >
              <a>
                {' '}
                {item.archived ? `${item.fullName} (archived)` : item.fullName}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ComboboxEmployee;
